import {Injectable} from '@angular/core';
import {Base2Service, BaseService} from '../../../../services';
import {AddProductBcDto} from '../DTO/add-product-bc.dto';
import {ProductBcDto, ResponseProductBC} from "../DTO/productBc.dto";

@Injectable({
  providedIn: 'root'
})
export class ProductAddQuickService  extends BaseService {

  getProductBC(query?) {
    return this.get2<ResponseProductBC>('product/get/BC' , {params : query});
  }

  addProductBC(params: AddProductBcDto) {
    return this.post2('product/add/BC' , params);
  }
}
